export default __webpack_public_path__ + "static/media/bottom.1d4b992b.svg";